var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6364 14.0912V12.6366C12.6364 11.03 11.3339 9.72754 9.72727 9.72754H3.90909C2.30244 9.72754 1 11.03 1 12.6366V14.0912",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81827 6.81818C8.42492 6.81818 9.72736 5.51574 9.72736 3.90909C9.72736 2.30244 8.42492 1 6.81827 1C5.21162 1 3.90918 2.30244 3.90918 3.90909C3.90918 5.51574 5.21162 6.81818 6.81827 6.81818Z",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 14.0909V12.6363C16.9992 11.3106 16.102 10.1532 14.8184 9.82178",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9092 1.09473C13.1964 1.4243 14.0967 2.58417 14.0967 3.91291C14.0967 5.24164 13.1964 6.40151 11.9092 6.73109",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkers);
export default __webpack_public_path__ + "static/media/workers.2fc43955.svg";
export { ForwardRef as ReactComponent };